"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pessina-cremonese": {
    "759da4c3": [{
      "hkey": "2fd54f86",
      "slug": "monticelli-ripa-d-oglio",
      "name": "Monticelli Ripa d'Oglio",
      "primary": true,
      "skipSearch": false
    }],
    "monticelli-ripa-oglio": [{
      "hkey": "2fd54f86",
      "slug": "monticelli-ripa-d-oglio",
      "name": "Monticelli Ripa d'Oglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;